/**
 * Product Counts Interface
 * Used for filter sidebar counts
 * Based on old QMC QPilotProductSummariesCount class
 */
export interface IProductCounts {
  // Basic counts
  TotalCount: number;
  ActiveCount: number;
  InactiveCount: number;
  InvalidCount: number;

  // Stock level counts
  InStockCount: number;
  LowStockCount: number;
  OutOfStockCount: number;

  // By product type
  SimpleCount: number;
  VariableCount: number;
  BundleCount: number;
  GroupedCount: number;
}

/**
 * Default empty counts object
 */
export const DEFAULT_PRODUCT_COUNTS: IProductCounts = {
  TotalCount: 0,
  ActiveCount: 0,
  InactiveCount: 0,
  InvalidCount: 0,
  InStockCount: 0,
  LowStockCount: 0,
  OutOfStockCount: 0,
  SimpleCount: 0,
  VariableCount: 0,
  BundleCount: 0,
  GroupedCount: 0,
};
